<template>
  <div  class="form-container">
    <div class="tab-container">
      <el-row>
        <el-col :offset="12" :span="12">
         <el-radio-group v-model="section">
          <el-radio-button label="Section A"></el-radio-button>
          <el-radio-button label="Section B"></el-radio-button>
          <el-radio-button label="Section C"></el-radio-button>
        </el-radio-group>
        </el-col>
      </el-row>
    </div>
    <hr style="border:1px solid #dadde2;">
      <div v-if="section==='Section A'">
        <que-section1 :questions1="Questions"></que-section1>
      </div>
      <div v-if="section==='Section B'">
        <que-section2></que-section2>
      </div>
      <div v-if="section==='Section C'">
        <que-section3></que-section3>
      </div>
      <!-- <div class="row" style="margin-top:2rem;">
        <i class="el-icon-caret-left sectionPrev" @click="secPrev()"></i>
        <i class="el-icon-caret-right sectionNext" @click="secNext()"></i>
    </div> -->
    <div class="row" style="margin-left:0px;">
        <el-button class="btn-theme surveyPrev" @click="clickPrev()" style="width:6rem; margin-right: 43rem;">Previous</el-button>
        <el-button class="btn-theme surveyNext" @click="clickNext()" style="width:6rem;">Next</el-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      section: 'Section A',
      Questions: ''
    }
  },
  methods: {
    ...mapActions({
      fetchQuestions: 'Survey/fetchQuestions'
    }),
    secNext () {
      if (this.section < 3) {
        this.section++
      }
    },
    secPrev () {
      if (this.section > 1) {
        this.section--
      }
    },
    clickPrev () {
      this.$emit('prev', 1)
    },
    clickNext () {
      this.$emit('next', 2)
    }
  },
  computed: {
    ...mapGetters({
      getQuestions: 'Survey/getQuestions'
    })
  },
  watch: {
    getQuestions (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.Questions = value.data
      } else {
        this.$message.error(value.message)
      }
      console.log('Q details', this.Questions)
    },
    Questions (value) {
      console.log('Q updated', this.Questions)
    }
  },
  mounted () {
    this.fetchQuestions()
  }
}
</script>
<style >
.el-icon-caret-left {
  color: #1C2B36;
}
.el-icon-caret-right{
  color: #1C2B36;
}
.sectionNext {
  margin-left: 90%;
  font-size: 2rem;
}
.sectionPrev {
  left: 0px;
  font-size: 2rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Survey/QuestionDetails.vue